import * as Yup from "yup";

export const LedgerAccountValidationSchema = Yup.object().shape({
  code: Yup.string().required("Required!"),
  name: Yup.string().required("Required!"),
  accountType: Yup.string().required("Required!"),
  description: Yup.string().nullable(),
});
